import * as React from 'react';
import classNames from 'classnames';
import { IFilesNameListProps } from '../../FileUploader.types';
import { testIds } from '../../constants';
import { FileName } from '../FileName/FileName';
import style from './style/FilesNameList.scss';

export const FilesNameList: React.FunctionComponent<IFilesNameListProps> = ({
  id,
  skin,
  disabled,
  value,
  placeholderLabel,
  withErrorIndication,
  withErrorTooltip,
  validationMessage,
  onFileRemoval,
  onXIconKeyDown,
}) => {
  const isPlaceholder = !value.length;
  const fileName = isPlaceholder ? placeholderLabel || ' ' : value[0].name;

  const fileListClassName = classNames(style.fileList, style[skin], {
    [style.placeholder]: isPlaceholder,
  });

  return (
    <div className={fileListClassName} data-testid={testIds.fileList}>
      <FileName
        id={id}
        fileName={fileName}
        disabled={disabled}
        isPlaceholder={isPlaceholder}
        withErrorIndication={withErrorIndication}
        withErrorTooltip={withErrorTooltip}
        validationMessage={validationMessage}
        onFileRemoval={onFileRemoval}
        onXIconKeyDown={onXIconKeyDown}
      />
    </div>
  );
};
